module.exports = __webpack_public_path__ + "a244f2228ef15a1bd19f6d768a98da9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/g/g12.jpg
// module id = 574
// module chunks = 0